import React from 'react';
import bindAll from 'lodash.bindall';
import { Box } from "@chakra-ui/react";
import PropTypes from 'prop-types';
import {compose} from 'redux';
import {injectIntl, FormattedMessage, defineMessages } from 'react-intl';
import {connect} from 'react-redux';
import { setConnectModal } from '../store/modals'
import { setConnectionMode } from '../store/connect-state'
import startUsb from '../lib/assets/start_usb.svg';
import startBluetooth from '../lib/assets/start_bluetooth.svg'
import CustomModal from './custom-modal.jsx';
import modalBack from '../lib/assets/modalWifi.png'
import './connection-bulletbox.css';


const messages = defineMessages({
    connectionMethodTitle: {
        defaultMessage: "Device Connection Method",
        id: "gui.upgrade.connectionMethod",
        description: "Device Connection Method",
    }
})
class ConnectionBulletbox extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleMethodCancel',
            'handleBleConnect',
            'handleConnectUSB'
        ]);
        this.state = {
            connectionMethodStatus: false
        };
    }
    componentDidUpdate() {
    }
    componentDidMount () {
    }
    handleMethodCancel () {
        this.props.setConnectModal(false);
    }

    // 点击连接usb
    handleConnectUSB () {
        this.props.setConnectionMode('usb');
        window.peripheral.usb('0x303a')
        // window.peripheral.connect()
        // if (window.peripheral.isConnected()) {
        //     // this.props.
        //     // this.props.onShowExtensionAlert('Nous');
        // } else {
        //     this.props.vm.connectUsbPeripheral('Nous', '0x303a');
        // }
    }
    // 点击连接蓝牙
    handleBleConnect () {
        this.props.setConnectionMode('ble');
        window.peripheral.scan('0x303a')
        // window.peripheral.disconnect()
        // if (this.props.vm.getPeripheralIsConnected('Nous')) {
        //     this.props.onShowExtensionAlert('Nous');
        // } else {
        //     this.props.setModalExtensionId('Nous');
        //     this.props.vm.scanForPeripheral('Nous', '0x303a');
        // }
        // this.props.closeConnectionMethod();
        // this.props.onShowExtensionAlert('Nous');
    }
    render () {
        const connectionUsb = (
            <FormattedMessage
                defaultMessage="USB"
                id="gui.upgrade.connectionUsb"
            />
        );
        const connectionBle = (
            <FormattedMessage
                defaultMessage="Bluetooth"
                id="gui.upgrade.connectionBle"
            />
        );
        return (
            <Box>
                <CustomModal
                    id="connectionMethodModal"
                    headerImageTop={modalBack}
                    contentLabel={this.props.intl.formatMessage(messages.connectionMethodTitle)}
                    overlayClassName="connectBoxmodalOverlay"
                    className="connectBoxModal"
                    onRequestClose={this.handleMethodCancel}
                    hasHeaderLine={false}
                >
                    <div className="connectBoxcontainer">
                        <div className="connectBoxMethodContent">
                            <div
                                className="connectBoxTypes"
                                onClick={this.handleMethodCancel}
                            >
                                <div
                                    className="connectBoxType"
                                    onClick={this.handleConnectUSB}
                                >
                                    <img src={startUsb} />
                                    <div>
                                        {connectionUsb}
                                    </div>
                                </div>
                                <div
                                    className="connectBoxType"
                                    onClick={this.handleBleConnect}
                                >
                                    <img src={startBluetooth} />
                                    <div>
                                        {connectionBle}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </CustomModal>
            </Box>
        );
    }
}

ConnectionBulletbox.propTypes = {
    connectModalState: PropTypes.bool
    // setModalExtensionId: PropTypes.func
};

ConnectionBulletbox.defaultProps = {
};

const mapStateToProps = state => ({
    connectModalState: state.modalsStore.connectModalState
});

const mapDispatchToProps = dispatch => ({
    setConnectModal: state => dispatch(setConnectModal(state)),
    setConnectionMode: mode => {dispatch(setConnectionMode(mode))}
});

export default compose(
    injectIntl,
    connect(
        mapStateToProps,
        mapDispatchToProps
    )
)(ConnectionBulletbox);
